import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import AuthRoute from './components/AuthRoute';

function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/login" component={Login} />
          <AuthRoute path="/">
            <Home />
          </AuthRoute>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
